import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { useI18n } from '../i18n';
import { onShedChange, sharedShedStore } from '../lib/shed/ShedContext';
import { dueReminders } from '../lib/calendar/model';

// Foreground only: no permission request/background alarm claim/server upload.
export default function CalendarReminderGate() {
  const { user } = useAuth(), { locale } = useI18n(), navigate = useNavigate();
  const owner = user?.user_id || 'device';
  useEffect(() => {
    let alive = true, running = false;
    const shown = new Set(), toastIds = new Set();
    const key = `growdaily-calendar-seen:${owner}`;
    try { JSON.parse(localStorage.getItem(key) || '[]').slice(-200).forEach(id=>shown.add(id)); } catch { /* session fallback */ }
    const check = async () => {
      if (!alive || running || document.visibilityState === 'hidden') return;
      running = true;
      try {
        const { store } = await sharedShedStore();
        if (!alive) return;
        const rows = await store.list(owner, 'calendar_event');
        if (!alive || document.visibilityState === 'hidden') return;
        for (const e of dueReminders(rows).filter(event=>!shown.has(`${event.occurrenceId}:${event.reminderMs}`)).slice(0,3)) {
          const identity = `${e.occurrenceId}:${e.reminderMs}`;
          shown.add(identity);
          const id = `calendar:${owner}:${identity}`; toastIds.add(id);
          toast(e.title, { id, duration: 10000, description: `${e.date} · ${e.allDay ? (locale==='da'?'Hele dagen':'All day') : e.time}`,
            action: { label: locale==='da'?'Åbn kalender':'Open calendar', onClick:()=>{if(alive)navigate('/shed/calendar');} } });
        }
        try { localStorage.setItem(key, JSON.stringify([...shown].slice(-200))); } catch { /* no durable acknowledgement */ }
      } finally { running = false; }
    };
    const safeCheck=()=>{check().catch(()=>{});};
    safeCheck();
    const timer=setInterval(safeCheck,60000), off=onShedChange(safeCheck);
    document.addEventListener('visibilitychange',safeCheck);
    return()=>{alive=false;clearInterval(timer);off();document.removeEventListener('visibilitychange',safeCheck);toastIds.forEach(id=>toast.dismiss(id));};
  },[owner,locale,navigate]);
  return null;
}
